/* Design Beldi - interactions du thème */
(function () {
  // Hauteur du header pour le hero plein écran sous le header transparent
  function setHeaderHeight() {
    var h = document.querySelector('.section-header');
    if (h) document.documentElement.style.setProperty('--db-header-h', h.offsetHeight + 'px');
  }
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('DOMContentLoaded', setHeaderHeight);

  // Défilement automatique aller-retour de la rangée produits
  if (!customElements.get('db-autoscroll')) {
    customElements.define('db-autoscroll', class extends HTMLElement {
      connectedCallback() {
        var self = this, speed = parseFloat(this.dataset.speed || 0);
        if (!speed || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.v = speed * 0.18; this.dir = 1; this.pos = this.scrollLeft; this.hold = false; this.visible = false;
        var pause = function () { self.hold = true; clearTimeout(self.t); };
        var resume = function () { clearTimeout(self.t); self.t = setTimeout(function () { self.pos = self.scrollLeft; self.hold = false; }, 2500); };
        this.addEventListener('mouseenter', pause); this.addEventListener('mouseleave', resume);
        this.addEventListener('pointerdown', pause); this.addEventListener('touchstart', pause, { passive: true });
        this.addEventListener('touchend', resume); this.addEventListener('pointerup', resume);
        this.addEventListener('focusin', pause); this.addEventListener('focusout', resume);
        this.addEventListener('wheel', function () { pause(); resume(); }, { passive: true });
        new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; }).observe(this);
        var step = function () {
          if (!self.isConnected) return;
          if (!self.hold && self.visible) {
            var max = self.scrollWidth - self.clientWidth;
            if (max > 2) {
              self.pos += self.v * self.dir;
              if (self.pos >= max) { self.pos = max; self.dir = -1; }
              if (self.pos <= 0) { self.pos = 0; self.dir = 1; }
              self.scrollLeft = self.pos;
            }
          }
          requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    });
  }

  // Rangées défilantes : défilement continu + glisser (souris / doigt) + flèches + changement de photo
  if (!customElements.get('db-product-marquee')) {
    customElements.define('db-product-marquee', class extends HTMLElement {
      connectedCallback() {
        var self = this, btn = this.querySelector('.db-pm__toggle');
        this.track = this.querySelector('.db-pm__track');
        this.paused = false; this.visible = true; this.hover = false; this.x = 0; this.vel = 0; this.tween = null; this.drag = null;
        if (btn) btn.addEventListener('click', function () {
          self.paused = !self.paused;
          self.classList.toggle('is-paused', self.paused);
          btn.setAttribute('aria-pressed', self.paused);
          btn.setAttribute('aria-label', self.paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
        });
        this.io = new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; });
        this.io.observe(this);
        var sec = parseFloat(this.dataset.swap || 0);
        if (sec > 0 && this.querySelector('.db-card__alt')) {
          this.timer = setInterval(function () { if (!self.paused && self.visible && !document.hidden) self.classList.toggle('is-alt'); }, sec * 1000);
        }
        if (this.classList.contains('is-static') || !this.track) return;
        this.classList.add('is-js');
        this.measure();
        this.ro = new ResizeObserver(function () { self.measure(); }); this.ro.observe(this.track);
        this.addEventListener('mouseenter', function () { self.hover = true; });
        this.addEventListener('mouseleave', function () { self.hover = false; });
        this.querySelectorAll('.db-pm__arrow').forEach(function (a) {
          a.addEventListener('click', function () { self.nudge(a.dataset.dir === 'prev' ? 1 : -1); });
        });
        this.initDrag();
        var last = performance.now();
        var loop = function (now) {
          if (!self.isConnected) return;
          var dt = Math.min(0.05, (now - last) / 1000); last = now;
          if (self.tween) {
            var t = Math.min(1, (now - self.tween.t0) / self.tween.d), e = 1 - Math.pow(1 - t, 3);
            self.x = self.tween.from + (self.tween.to - self.tween.from) * e;
            if (t >= 1) self.tween = null;
          } else if (!self.drag) {
            if (Math.abs(self.vel) > 5) { self.x += self.vel * dt; self.vel *= Math.pow(0.04, dt); }
            else { self.vel = 0; if (!self.paused && !self.hover && self.visible && !document.hidden) self.x -= self.speed * dt; }
          }
          self.apply();
          requestAnimationFrame(loop);
        };
        requestAnimationFrame(loop);
      }
      measure() {
        var dur = parseFloat(getComputedStyle(this).getPropertyValue('--db-pm-dur')) || 70;
        this.half = this.track.scrollWidth / 2 || 1;
        this.speed = this.half / dur;
        var card = this.track.querySelector('.db-card, .db-comm__item');
        this.step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(card.parentElement).columnGap || 16) : 320;
      }
      wrap(v) { var h = this.half; while (v <= -h) v += h; while (v > 0) v -= h; return v; }
      apply() { this.x = this.wrap(this.x); this.track.style.transform = 'translate3d(' + this.x + 'px,0,0)'; }
      nudge(dir) {
        var from = this.tween ? this.tween.to : this.x;
        this.vel = 0; this.tween = { from: this.x, to: from + dir * this.step, t0: performance.now(), d: 650 };
      }
      initDrag() {
        var self = this, st = null, moved = false, lastX = 0, lastT = 0, v = 0;
        this.track.addEventListener('pointerdown', function (e) {
          if (e.button !== 0 || e.target.closest('.db-qa, button')) return;
          st = { x: e.clientX, y: e.clientY, ox: self.x, id: e.pointerId }; moved = false; lastX = e.clientX; lastT = performance.now(); v = 0;
        });
        this.track.addEventListener('pointermove', function (e) {
          if (!st || e.pointerId !== st.id) return;
          var dx = e.clientX - st.x, dy = e.clientY - st.y;
          if (!moved) {
            if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { st = null; return; }
            if (Math.abs(dx) < 6) return;
            moved = true; self.drag = true; self.tween = null; self.vel = 0; self.classList.add('is-dragging');
            try { self.track.setPointerCapture(e.pointerId); } catch (x) {}
          }
          var now = performance.now(), dtm = Math.max(1, now - lastT);
          v = 0.8 * ((e.clientX - lastX) / dtm * 1000) + 0.2 * v; lastX = e.clientX; lastT = now;
          self.x = st.ox + dx;
        });
        var end = function (e) {
          if (!st) return;
          if (moved) { self.vel = Math.max(-2200, Math.min(2200, v)); self.drag = null; self.classList.remove('is-dragging'); }
          st = null;
        };
        this.track.addEventListener('pointerup', end); this.track.addEventListener('pointercancel', end);
        this.track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      disconnectedCallback() { clearInterval(this.timer); if (this.io) this.io.disconnect(); if (this.ro) this.ro.disconnect(); }
    });
  }

  // Compte à rebours (date + heure dans un fuseau horaire précis)
  if (!customElements.get('db-countdown')) {
    customElements.define('db-countdown', class extends HTMLElement {
      connectedCallback() {
        var d = (this.dataset.date || '').split('-').map(Number), t = (this.dataset.time || '00:00').split(':').map(Number);
        if (d.length < 3 || !d[0]) return;
        this.target = this.zoned(d[0], d[1] - 1, d[2], t[0] || 0, t[1] || 0, this.dataset.tz || 'Europe/Brussels');
        this.nums = {}; var self = this;
        this.querySelectorAll('[data-u]').forEach(function (n) { self.nums[n.dataset.u] = n; });
        this.tick(); this.timer = setInterval(function () { self.tick(); }, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      zoned(y, mo, da, h, mi, tz) {
        var guess = Date.UTC(y, mo, da, h, mi);
        try {
          var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
          var p = {}; f.formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = +x.value; });
          var asTz = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
          return guess - (asTz - guess);
        } catch (e) { return guess; }
      }
      set(u, v) {
        var n = this.nums[u]; if (!n) return;
        var s = v < 10 ? '0' + v : String(v);
        if (n.textContent !== s) { n.textContent = s; n.classList.remove('is-tick'); void n.offsetWidth; n.classList.add('is-tick'); }
      }
      tick() {
        var ms = this.target - Date.now();
        if (ms <= 0) {
          clearInterval(this.timer);
          ['d', 'h', 'm', 's'].forEach(function (u) { this.set(u, 0); }, this);
          this.classList.add('is-live');
          var l = this.querySelector('.db-cd__live'); if (l) l.hidden = false;
          return;
        }
        var s = Math.floor(ms / 1000);
        this.set('d', Math.floor(s / 86400)); this.set('h', Math.floor(s % 86400 / 3600));
        this.set('m', Math.floor(s % 3600 / 60)); this.set('s', s % 60);
      }
    });
  }

  // Menu Catégories plein écran (ordinateur)
  (function () {
    var init = function () {
      var d = document.getElementById('Details-HeaderMenu-db'); if (!d || d.dataset.dbInit) return; d.dataset.dbInit = '1';
      var sum = d.querySelector('summary'), li = d.closest('li'), hoverable = window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
      var setH = function () { var h = document.querySelector('.section-header'); if (h) document.documentElement.style.setProperty('--db-header-bottom', Math.round(h.getBoundingClientRect().bottom) + 'px'); };
      var open = function () { setH(); d.setAttribute('open', ''); sum.setAttribute('aria-expanded', 'true'); document.body.classList.add('db-fm-open'); };
      var close = function () { d.removeAttribute('open'); sum.setAttribute('aria-expanded', 'false'); document.body.classList.remove('db-fm-open'); };
      new MutationObserver(function () { document.body.classList.toggle('db-fm-open', d.hasAttribute('open')); if (d.hasAttribute('open')) setH(); }).observe(d, { attributes: true, attributeFilter: ['open'] });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.hasAttribute('open')) { close(); sum.focus(); } });
      d.querySelectorAll('.db-fm__cat[data-i]').forEach(function (c) {
        var act = function () {
          d.querySelectorAll('.db-fm__cat[data-i]').forEach(function (x) { x.classList.toggle('is-active', x === c); });
          d.querySelectorAll('.db-fm__sub').forEach(function (x) { x.classList.toggle('is-active', x.dataset.i === c.dataset.i); });
        };
        c.addEventListener('mouseenter', act); c.addEventListener('focus', act);
        if (c.getAttribute('href') === '#') c.addEventListener('click', function (e) { e.preventDefault(); act(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  // Texte sur image : léger zoom arrière à l'apparition
  (function () {
    var els = document.querySelectorAll('.db-ti'); if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold: .25 });
    els.forEach(function (e) { io.observe(e); });
    document.addEventListener('shopify:section:load', function (ev) { ev.target.querySelectorAll('.db-ti').forEach(function (e) { e.classList.add('is-in'); }); });
  })();

  // Ajout rapide
  if (!customElements.get('db-quick-add')) {
    customElements.define('db-quick-add', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var open = this.querySelector('.db-qa__btn');
        if (open) open.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.classList.add('is-open'); var f = self.querySelector('.db-qa__size:not([disabled])'); if (f) f.focus(); });
        this.querySelectorAll('.db-qa__size').forEach(function (b) {
          b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.add(b.dataset.variantId); });
        });
        this.addEventListener('click', function (e) { if (e.target.closest('.db-qa')) e.preventDefault(); });
      }
      add(id) {
        var self = this;
        var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var body = { items: [{ id: Number(id), quantity: 1 }] };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { alert(res.description || res.message); self.classList.remove('is-open'); return; }
            self.classList.remove('is-open'); self.classList.add('is-done');
            setTimeout(function () { self.classList.remove('is-done'); }, 1600);
            if (drawer && drawer.renderContents && res.sections) {
              var data = res.items ? Object.assign({}, res.items[0], { sections: res.sections }) : res;
              drawer.renderContents(data);
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; });
      }
    });
  }

  // Shop the look (carrousel de looks, v15-29)
  if (!customElements.get('db-look')) {
    customElements.define('db-look', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.slides = Array.from(this.querySelectorAll('.db-look__slide'));
        this.bars = Array.from(this.querySelectorAll('.db-look__bar'));
        this.curEl = this.querySelector('.db-look__cur');
        this.cur = 0;
        this.querySelectorAll('.db-spot').forEach(function (s) {
          s.addEventListener('click', function () { self.stop(); self.show(s.dataset.index); });
        });
        this.querySelectorAll('.db-look__arrow').forEach(function (b) {
          b.addEventListener('click', function () { self.stop(); self.go(self.cur + Number(b.dataset.dir)); });
        });
        var media = this.querySelector('.db-look__media'), x0 = null, y0 = null;
        if (media && this.slides.length > 1) {
          media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
          media.addEventListener('touchend', function (e) {
            if (x0 === null) return;
            var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
            if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { self.stop(); self.go(self.cur + (dx < 0 ? 1 : -1)); }
          });
          media.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { self.stop(); self.go(self.cur + (e.key === 'ArrowRight' ? 1 : -1)); } });
        }
        this.go(0, true);
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.io = new IntersectionObserver(function (es) { es.forEach(function (en) { self.visible = en.isIntersecting; if (self.visible && !self.stopped) self.play(); else self.pause(); }); }, { threshold: .35 });
          this.io.observe(this);
        } else { this.classList.add('is-paused'); }
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', function (e) {
            if (!self.contains(e.target)) return;
            self.stop();
            if (e.target.classList.contains('db-look__slide')) self.go(Number(e.target.dataset.slide));
            else if (e.target.classList.contains('db-spot')) { self.go(Number(e.target.dataset.slide), true); self.show(e.target.dataset.index); }
          });
        }
      }
      disconnectedCallback() { clearInterval(this.t); if (this.io) this.io.disconnect(); }
      play() { var self = this; clearInterval(this.t); this.classList.remove('is-paused'); this.restartBar(); this.t = setInterval(function () { self.go(self.cur + 1); }, Number(this.dataset.interval || 6) * 1000); }
      pause() { clearInterval(this.t); }
      stop() { this.stopped = true; clearInterval(this.t); this.classList.add('is-paused'); }
      restartBar() { var b = this.bars[this.cur]; if (!b) return; b.classList.remove('is-active'); void b.offsetWidth; b.classList.add('is-active'); }
      go(n, silent) {
        var len = this.slides.length; if (!len) return;
        n = (n + len) % len; this.cur = n;
        this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); if (i === n) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
        this.bars.forEach(function (b, i) { b.classList.toggle('is-done', i < n); b.classList.remove('is-active'); });
        if (this.bars[n]) { void this.bars[n].offsetWidth; this.bars[n].classList.add('is-active'); }
        if (this.curEl) this.curEl.textContent = (n + 1 < 10 ? '0' : '') + (n + 1);
        var lookCard = this.querySelector('.db-look__card[data-look][data-slide="' + n + '"]');
        var first = this.querySelector('.db-spot[data-slide="' + n + '"]');
        this.show(lookCard ? lookCard.dataset.index : (first ? first.dataset.index : null), silent);
      }
      show(i) {
        var any = false;
        this.querySelectorAll('.db-spot').forEach(function (s) { var on = s.dataset.index === i; s.classList.toggle('is-active', on); s.setAttribute('aria-pressed', on); });
        this.querySelectorAll('.db-look__card').forEach(function (c) { var on = c.dataset.index === i; c.classList.toggle('is-active', on); if (on) any = true; });
      }
    });
  }

  // Vue 360 : séquence d'images
  if (!customElements.get('db-360')) {
    customElements.define('db-360', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.stage = this.querySelector('.db-360__stage');
        this.persona = null; this.idx = 0;
        this.querySelectorAll('.db-360__persona').forEach(function (b) {
          b.addEventListener('click', function () { self.setPersona(b.dataset.persona); });
        });
        var first = this.querySelector('.db-360__persona');
        if (first) this.setPersona(first.dataset.persona);
        if (!this.stage) return;
        var drag = false, sx = 0, si = 0;
        this.stage.addEventListener('pointerdown', function (e) { drag = true; sx = e.clientX; si = self.idx; try { self.stage.setPointerCapture(e.pointerId); } catch (x) {} });
        this.stage.addEventListener('pointermove', function (e) {
          if (!drag || !self.frames.length || self.isFlip()) return;
          var step = Math.max(6, self.stage.offsetWidth / self.frames.length / 1.2);
          var n = self.frames.length;
          self.go(((si - Math.round((e.clientX - sx) / step)) % n + n) % n);
        });
        ['pointerup', 'pointercancel'].forEach(function (t) { self.stage.addEventListener(t, function (e) {
          if (drag && self.isFlip() && t === 'pointerup') {
            var dx = e.clientX - sx;
            if (Math.abs(dx) > 30) self.flip(dx < 0 ? 1 : -1); else if (Math.abs(dx) < 6) self.flip(1);
          }
          drag = false;
        }); });
        this.stage.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : (e.key === 'Enter' || e.key === ' ') ? 1 : 0;
          if (!d || !self.frames.length) return;
          e.preventDefault();
          if (self.isFlip()) self.flip(d); else self.go((self.idx + d + self.frames.length) % self.frames.length);
        });
      }
      setPersona(p) {
        this.persona = p;
        this.querySelectorAll('.db-360__persona').forEach(function (b) { b.classList.toggle('is-active', b.dataset.persona === p); b.setAttribute('aria-pressed', b.dataset.persona === p); });
        this.querySelectorAll('.db-360__frame').forEach(function (f) { f.classList.remove('is-on'); });
        this.frames = Array.prototype.slice.call(this.querySelectorAll('.db-360__frame[data-persona="' + p + '"]'));
        this.frames.forEach(function (f) { if (f.loading === 'lazy') f.loading = 'eager'; });
        this.go(0);
      }
      // Moins de 8 photos (ex. dos + face) : le mannequin pivote en 3D d'une photo à l'autre
      isFlip() { return this.frames && this.frames.length > 1 && this.frames.length < 8; }
      flip(dir) {
        var self = this, st = this.stage, n = this.frames.length;
        if (this.flipping || n < 2) return;
        this.flipping = true;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { this.go((this.idx + dir + n) % n); this.flipping = false; return; }
        st.style.transition = 'transform .32s cubic-bezier(.55,0,.75,.4)';
        st.style.transform = 'perspective(1400px) rotateY(' + (-dir * 90) + 'deg)';
        setTimeout(function () {
          self.go((self.idx + dir + n) % n);
          st.style.transition = 'none';
          st.style.transform = 'perspective(1400px) rotateY(' + (dir * 90) + 'deg)';
          void st.offsetWidth;
          st.style.transition = 'transform .45s cubic-bezier(.2,.7,.25,1)';
          st.style.transform = 'perspective(1400px) rotateY(0deg)';
          setTimeout(function () { self.flipping = false; }, 460);
        }, 320);
      }
      go(i) {
        if (!this.frames || !this.frames.length) return;
        if (this.frames[this.idx]) this.frames[this.idx].classList.remove('is-on');
        this.idx = i; this.frames[i].classList.add('is-on');
      }
    });
  }

  // Vue 360 de démonstration : t-shirt 3D en CSS
  if (!customElements.get('db-tee')) {
    customElements.define('db-tee', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.spin = this.querySelector('.db-tee__spin');
        this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.rot = 0; this.i = 0;
        this.querySelectorAll('.db-360__persona').forEach(function (b, k) { b.addEventListener('click', function () { if (k !== self.i) self.turn(k > self.i ? 1 : -1, k); }); });
        var drag = false, sx = 0, sr = 0;
        this.spin.addEventListener('pointerdown', function (e) { drag = true; sx = e.clientX; sr = self.rot; self.spin.classList.add('is-drag'); try { self.spin.setPointerCapture(e.pointerId); } catch (x) {} });
        this.spin.addEventListener('pointermove', function (e) { if (!drag) return; self.rot = sr + (e.clientX - sx) * .6; self.apply(); });
        var up = function (e) {
          if (!drag) return; drag = false; self.spin.classList.remove('is-drag');
          var dx = e.clientX - sx;
          if (Math.abs(dx) > 160) self.turn(dx > 0 ? -1 : 1);
          else { self.rot = Math.round(self.rot / 180) * 180; self.apply(); }
        };
        this.spin.addEventListener('pointerup', up); this.spin.addEventListener('pointercancel', up);
        this.render();
      }
      turn(dir, target) {
        var r = this.rot;
        this.rot = dir > 0 ? Math.floor(r / 360) * 360 - 360 : Math.ceil(r / 360) * 360 + 360;
        var n = this.data.length;
        this.i = target !== undefined ? target : (this.i + dir + n) % n;
        this.apply(); this.render();
      }
      apply() { this.spin.style.transform = 'rotateY(' + this.rot + 'deg)'; }
      render() {
        var d = this.data[this.i], self = this;
        this.querySelectorAll('[data-fill]').forEach(function (p) { p.setAttribute('fill', d.fill); p.setAttribute('stroke', d.stroke); });
        this.querySelectorAll('[data-ink]').forEach(function (p) { p.setAttribute('fill', d.ink); });
        var pr = this.querySelector('.db-tee__print');
        pr.style.color = d.ink;
        pr.querySelector('[data-l1]').textContent = d.line1;
        pr.querySelector('[data-l2]').textContent = d.line2;
        this.querySelectorAll('.db-360__persona').forEach(function (b, k) { b.classList.toggle('is-active', k === self.i); b.setAttribute('aria-pressed', k === self.i); });
      }
    });
  }

  // Citation tapée lettre par lettre
  if (!customElements.get('db-typewriter')) {
    customElements.define('db-typewriter', class extends HTMLElement {
      connectedCallback() {
        var out = this.querySelector('[data-out]');
        var full = this.dataset.text || '';
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { out.textContent = full; return; }
        var t = 0, self = this, started = false;
        var tick = function () { t = t >= full.length + 25 ? 0 : t + 1; out.textContent = full.slice(0, Math.min(t, full.length)); };
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !started) { started = true; self.timer = setInterval(tick, 70); }
        });
        io.observe(this);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
})();

/* v15-21 : recherche ordinateur, ouverture au clic sur la loupe */
(function () {
  function init() {
    document.querySelectorAll('.db-isearch-wrap').forEach(function (w) {
      if (w.dataset.dbReady) return; w.dataset.dbReady = '1';
      var btn = w.querySelector('.db-isearch__toggle'), input = w.querySelector('.db-isearch__input'), form = w.querySelector('form');
      if (!btn || !input) return;
      if (input.value) w.classList.add('is-open');
      function set(open) { w.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open); if (open) setTimeout(function () { input.focus(); }, 60); }
      btn.addEventListener('click', function () {
        if (w.classList.contains('is-open') && input.value.trim()) { form.submit(); return; }
        set(!w.classList.contains('is-open'));
      });
      document.addEventListener('click', function (e) { if (!w.contains(e.target) && !input.value) set(false); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; input.dispatchEvent(new Event('input', { bubbles: true })); set(false); btn.focus(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v15-23 : carrousel du hero */
if (!customElements.get('db-hero-slider')) {
  customElements.define('db-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.db-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.db-hero__dot'));
      this.i = 0;
      if (this.slides.length < 2) return;
      this.auto = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.ms = (parseFloat(this.dataset.interval) || 6) * 1000;
      var self = this;
      this.dots.forEach(function (d) { d.addEventListener('click', function () { self.go(+d.dataset.go, true); }); });
      var x0 = null;
      this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1), true);
      });
      document.addEventListener('visibilitychange', function () { self.pause(document.hidden); });
      this.addEventListener('shopify:block:select', function (e) { var n = self.slides.indexOf(e.target); if (n > -1) { self.go(n, false); self.stop(); } });
      this.addEventListener('shopify:block:deselect', function () { self.start(); });
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    start() {
      this.stop();
      if (!this.auto) return;
      this.classList.add('is-playing');
      this.restartBar();
      var self = this;
      this.t0 = Date.now(); this.left = this.ms;
      this.timer = setTimeout(function tick() { self.go(self.i + 1, false); }, this.ms);
    }
    stop() { clearTimeout(this.timer); this.classList.remove('is-playing'); }
    pause(on) {
      if (!this.auto) return;
      if (on && !this.paused) {
        this.paused = true; clearTimeout(this.timer);
        this.left = Math.max(400, this.left - (Date.now() - this.t0));
        this.classList.add('is-paused');
      } else if (!on && this.paused) {
        this.paused = false; this.classList.remove('is-paused');
        var self = this; this.t0 = Date.now();
        this.timer = setTimeout(function () { self.go(self.i + 1, false); }, this.left);
      }
    }
    restartBar() {
      var d = this.dots[this.i]; if (!d) return;
      var s = d.querySelector('span'); if (!s) return;
      d.classList.remove('is-active'); void s.offsetWidth; d.classList.add('is-active');
    }
    go(n, user) {
      var c = this.slides.length; n = (n + c) % c;
      var prev = this.slides[this.i], next = this.slides[n];
      if (prev) { prev.classList.remove('is-active'); prev.setAttribute('aria-hidden', 'true'); prev.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; }); }
      next.classList.add('is-active'); next.removeAttribute('aria-hidden'); next.querySelectorAll('a').forEach(function (a) { a.removeAttribute('tabindex'); });
      next.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      this.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); d.setAttribute('aria-selected', k === n); });
      this.i = n;
      if (this.slides[(n + 1) % c]) this.slides[(n + 1) % c].querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
      this.paused = false; this.classList.remove('is-paused');
      this.start();
    }
  });
}

/* v15-25 : choix du numéro + taille obligatoire */
if (!customElements.get('db-numbered')) {
  customElements.define('db-numbered', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      try { this.t = JSON.parse(this.querySelector('.db-num__i18n').textContent); } catch (e) { this.t = {}; }
      this.form = document.getElementById(this.dataset.form);
      this.sizeInput = this.querySelector('.db-num__size-input');
      this.err = this.querySelector('.db-num__err');
      this.num = null; this.size = null;
      this.multi = this.dataset.multi === 'true';
      this.groups = {};
      this.querySelectorAll('.db-num__choices').forEach(function (g) {
        var pre = g.querySelector('.db-num__choice.is-selected');
        self.groups[g.dataset.opt] = pre ? pre.dataset.val : null;
        g.querySelectorAll('.db-num__choice').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.db-num__choice').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
            b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true');
            self.groups[g.dataset.opt] = b.dataset.val;
            g.classList.remove('is-invalid');
            self.filter();
          });
        });
      });
      this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
      var nd = this.querySelector('[data-dd="num"]'); if (nd) { var ph = nd.querySelector('.db-num__ph'); nd.dataset.ph = ph ? ph.textContent : ''; }
      this.btn = this.form ? this.form.querySelector('[type="submit"]') : null;
      if (this.btn) { this.btnSpan = this.btn.querySelector('span') || this.btn; this.btnDefault = this.btnSpan.textContent.trim(); }
      this.querySelectorAll('.db-num__dd').forEach(function (dd) {
        var b = dd.querySelector('.db-num__btn');
        b.addEventListener('click', function (e) { e.stopPropagation(); self.toggle(dd); });
        b.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown') { e.preventDefault(); self.toggle(dd, true); } });
        dd.querySelectorAll('.db-num__opt').forEach(function (o) {
          if (!o.classList.contains('is-sold')) o.tabIndex = -1;
          o.addEventListener('click', function (e) { e.stopPropagation(); self.pick(dd, o); });
          o.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.pick(dd, o); }
            else if (e.key === 'Escape') { self.close(dd); b.focus(); }
            else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
              var all = Array.from(dd.querySelectorAll('.db-num__opt:not(.is-sold)')), k = all.indexOf(o) + (e.key === 'ArrowDown' ? 1 : -1);
              if (all[k]) all[k].focus();
            }
          });
        });
      });
      document.addEventListener('click', function () { self.querySelectorAll('.db-num__dd.is-open').forEach(function (d) { self.close(d); }); });
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (!self.num || !self.size) {
            e.preventDefault(); e.stopImmediatePropagation();
            self.showErr(!self.num ? self.t.err_number : self.t.err_size);
            self.querySelector('[data-dd="' + (!self.num ? 'num' : 'size') + '"]').classList.add('is-invalid');
          }
        }, true);
      }
      var g = this.querySelector('.db-num__guide');
      if (g) g.addEventListener('click', function (e) { var t = document.getElementById(g.getAttribute('href').slice(1)); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
      this.filter();
    }
    groupsReady() { for (var k in this.groups) { if (!this.groups[k]) return false; } return true; }
    filter() {
      var self = this, numDd = this.querySelector('[data-dd="num"]');
      if (!this.multi) { this.update(); return; }
      var ready = this.groupsReady(), free = 0, tot = 0;
      numDd.querySelectorAll('.db-num__opt').forEach(function (o) {
        var ok = ready;
        for (var k in self.groups) { if (ok && o.dataset['o' + k] !== self.groups[k]) ok = false; }
        o.hidden = !ok;
        if (ok) { tot++; if (!o.classList.contains('is-sold')) free++; }
        if (!ok && o.classList.contains('is-selected')) {
          o.classList.remove('is-selected'); self.num = null;
          numDd.querySelector('.db-num__btn').innerHTML = '<span class="db-num__ph"></span>';
          numDd.querySelector('.db-num__ph').textContent = numDd.dataset.ph || '';
        }
      });
      numDd.classList.toggle('is-locked', !ready);
      var c = this.querySelector('.db-num__count');
      if (c && ready) c.textContent = (this.dataset.counter || '').replace('[libres]', free).replace('[total]', tot);
      this.update();
    }
    toggle(dd, focusFirst) {
      if (dd.dataset.dd === 'num' && this.multi && !this.groupsReady()) {
        this.showErr(this.t.err_group);
        this.querySelectorAll('.db-num__choices').forEach(function (g) { if (!g.querySelector('.is-selected')) g.classList.add('is-invalid'); });
        return;
      }
      var open = !dd.classList.contains('is-open'), self = this;
      this.querySelectorAll('.db-num__dd.is-open').forEach(function (d) { if (d !== dd) self.close(d); });
      dd.classList.toggle('is-open', open);
      dd.querySelector('.db-num__btn').setAttribute('aria-expanded', open);
      if (open) {
        var sel = dd.querySelector('.is-selected') || dd.querySelector('.db-num__opt:not(.is-sold)');
        if (sel) { sel.scrollIntoView({ block: 'nearest' }); if (focusFirst) sel.focus(); }
      }
    }
    close(dd) { dd.classList.remove('is-open'); dd.querySelector('.db-num__btn').setAttribute('aria-expanded', 'false'); }
    pick(dd, o) {
      if (o.classList.contains('is-sold')) return;
      dd.querySelectorAll('.db-num__opt').forEach(function (x) { x.classList.remove('is-selected'); x.removeAttribute('aria-selected'); });
      o.classList.add('is-selected'); o.setAttribute('aria-selected', 'true');
      dd.querySelector('.db-num__btn').innerHTML = '<span></span>';
      dd.querySelector('.db-num__btn span').textContent = o.dataset.label;
      dd.classList.remove('is-invalid');
      this.close(dd); dd.querySelector('.db-num__btn').focus();
      if (dd.dataset.dd === 'num') {
        this.num = o.dataset.variant;
        if (this.idInput) { this.idInput.value = this.num; this.idInput.disabled = false; this.idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        try { var u = new URL(location.href); u.searchParams.set('variant', this.num); history.replaceState(null, '', u); } catch (e) {}
      } else {
        this.size = o.dataset.size;
        this.sizeInput.value = this.size; this.sizeInput.disabled = false;
      }
      this.err.hidden = true;
      this.update();
    }
    showErr(m) { this.err.textContent = m || ''; this.err.hidden = !m; }
    update() {
      if (!this.btn) return;
      var ok = this.num && this.size;
      var label = ok ? this.btnDefault : (this.multi && !this.groupsReady() ? this.t.choose_group : (!this.num && !this.size ? this.t.choose_both : (!this.num ? this.t.choose_number : this.t.choose_size)));
      if (this.btnSpan && label) this.btnSpan.textContent = label;
      this.btn.classList.toggle('db-num-wait', !ok);
      if (ok) { this.btn.disabled = false; this.btn.removeAttribute('aria-disabled'); }
    }
  });
}

/* v15-31 Menu mobile : les accordéons Catalogue / Collaborations s'ouvrent sur place.
   Sans ce correctif, le script Dawn du tiroir les traitait comme des sous-menus et faisait glisser tout le menu hors de l'écran (menu vide). */
document.addEventListener('click', function (e) {
  var s = e.target.closest && e.target.closest('#menu-drawer .db-dm > summary');
  if (!s) return;
  e.stopPropagation();
  var d = s.parentElement;
  setTimeout(function () { s.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false'); }, 0);
}, true);
